import { useMuteSoundNotificationStore } from '../hooks/useMuteSoundNotificationStore';
import { IconVolume, IconVolumeOff } from '@spotify-internal/encore-web';
import React from 'react';
import { IconButton } from '../design_system/IconButton';
export const SoundButtonController = ({ disabled, iconColor, }) => {
    const [muted, toggleSoundNotificationMute] = useMuteSoundNotificationStore();
    return (React.createElement(IconButton, { disabled: disabled, "aria-label": "mute notification sound", "$iconColor": iconColor, iconOnly: muted ? IconVolumeOff : IconVolume, onClick: toggleSoundNotificationMute, "data-testid": "chatbox-header-mute-notification-sound-button" }));
};
